import React from 'react';
const links = ['Termini di Servizio', 'Privacy Policy', 'Politica di Rimborso', 'Contatti'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-89" data-mp="3ggk6oqalp3xf">
      <div className="mx-auto max-w-5xl text-center" data-id="element-90" data-mp="32oe1fz8zkhcr">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-91" data-mp="32lrlbb814tix">
          INGLESE PRONTO™
        </p>
        <nav aria-label="Footer" data-id="element-92" data-mp="3ufa4y995p9nd">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-93" data-mp="3ug3bpa847z5i">
            {links.map(link => <li key={link} data-id="element-94" data-mp="3lem127dh8po7">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-95" data-mp="3ldanjfu8c3jw">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-96" data-mp="2eya1c1v0azqi">
          © 2026 INGLESE PRONTO™. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}